/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'star': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12 17.56l-5.806 4.238a.498.498 0 01-.767-.557l2.236-6.832-5.824-4.212a.498.498 0 01.292-.902l7.189.016 2.206-6.841a.498.498 0 01.948 0l2.206 6.84 7.189-.015a.498.498 0 01.292.902l-5.824 4.212 2.236 6.832a.498.498 0 01-.767.557L12 17.56z" _fill="currentColor" fill-rule="nonzero"/>'
  }
})
